import checkout from '../services/checkout';

// Noms conservés pour les appelants existants. La génération et le stockage
// sont maintenant effectués par le serveur depuis le paiement vérifié.
export const generateAndUploadReceipt = details => checkout.document('receipt', details.transaction_id);
export const generateAndUploadShippingForm = details => checkout.document('form', details.transaction_id);
